import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { MealSlot } from '../../../shared/enums';
import { ImageResourceService } from '../../../shared/services/image-resource.service';
import { PresentationController } from '../../presentation-controller';
import { SlideTextComponent } from '../../slide-text/slide-text.component';
import { TextOverflowDirective } from '../../text-overflow.directive';

const BIRTHDAY_CHANNEL_ID = -1;

@Component({
  selector: 'ds-backdrop-layout',
  imports: [NgStyle, SlideTextComponent, TextOverflowDirective],
  templateUrl: './backdrop-layout.component.html',
  styleUrls: ['./backdrop-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BackdropLayoutComponent {
  private readonly images = inject(ImageResourceService);

  public readonly controller = input.required<PresentationController>();
  public readonly slide = computed(() => this.controller().slide);
  public readonly background = computed(() => this.backgroundFor(this.slide()));

  private backgroundFor(slide: PresentationController['slide']): string {
    if (slide.content.providerChannelIds?.[0] === BIRTHDAY_CHANNEL_ID) {
      return 'url(assets/images/birthday.png)';
    }

    if (slide.mealSlot) {
      const name = `${MealSlot[slide.mealSlot].toLowerCase()}-bg.jpg`;

      return `url(${this.images.getImageUrl(name)}), url(assets/images/${name})`;
    }

    return slide.content.images?.[0] ?? '';
  }
}
